import {
  ChangeDetectionStrategy,
  Component,
  Input,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule, TypedBaseListComponent } from '@vendure/admin-ui/core';
import { BannerItem, GetBannerItemsDocument } from '../../../gql/graphql';
import { Observable } from 'rxjs';
import { marker as t } from '@biesbjerg/ngx-translate-extract-marker';

import { TruncatePipe } from '../../../common/truncate';

@Component({
  standalone: true,
  selector: 'banner-item-list',
  styleUrls: ['./banner-item-list.component.scss'],
  templateUrl: './banner-item-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, CommonModule, TruncatePipe],
})
export class BannerItemListComponent
  extends TypedBaseListComponent<typeof GetBannerItemsDocument, 'bannerItems'>
  implements OnInit, OnDestroy
{
  @Input() id: string;
  @Input() update: EventEmitter<void>;
  @Output() edit = new EventEmitter<BannerItem>();

  ngOnInit() {
    super.ngOnInit();
    this.update.subscribe({
      next: () => {
        this.refresh();
      },
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.update) this.update.unsubscribe();
  }

  readonly filters = this.createFilterCollection()
    .addFilter({
      name: 'start',
      type: { kind: 'dateRange' },
      label: t('grupo-loja.start-at'),
      filterField: 'start',
    })
    .addFilter({
      name: 'end',
      type: { kind: 'dateRange' },
      label: t('grupo-loja.end-at'),
      filterField: 'end',
    })
    .addFilter({
      name: 'link',
      type: { kind: 'text' },
      label: 'Link',
      filterField: 'link',
    })
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort('id', 'DESC')
    .addSort({ name: 'start' })
    .addSort({ name: 'end' })
    .addSort({ name: 'link' })
    .connectToRoute(this.route);

  constructor() {
    super();

    const refreshListOnChanges: Array<Observable<any>> = [
      this.filters.valueChanges,
      this.sorts.valueChanges,
    ];

    super.configure({
      document: GetBannerItemsDocument,
      getItems: data => data.bannerItems,
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: { ...this.filters.createFilterInput() },
          sort: this.sorts.createSortInput(),
        },
        banner: this.id ?? '',
      }),
      refreshListOnChanges,
    });
  }
  editItem(item: BannerItem) {
    this.edit.emit(item);
  }
}
